'use client';

import { FileUpload, type FileUploadProps } from '@components/ui';
import {
  Controller,
  type Control,
  type FieldErrors,
  type UseFormRegister,
} from 'react-hook-form';
import { Field, type FieldProps } from './field';

interface FormFileUploadProps
  extends
    Omit<FileUploadProps, 'onUpload'>,
    Omit<FieldProps, keyof FileUploadProps> {
  label: string;
  id: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  errors: FieldErrors;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const FormFileUpload: React.FC<FormFileUploadProps> = ({
  label,
  id,
  register,
  control,
  errors,
  disabled,
  helperText,
  isShowLabel = true,
  onChange,
  labelProps,
  disableLabel = false,
  labelContainerFlexDirection = 'column',
  required = false,
  inputProps,
  ...rest
}) => {
  return (
    <Field
      label={label}
      invalid={!!errors?.[id]}
      id={id}
      errorText={errors?.[id]?.message as string}
      helperText={helperText}
      isShowLabel={isShowLabel}
      disabled={disabled}
      disableLabel={disableLabel}
      width="fit-content"
      labelContainerFlexDirection={labelContainerFlexDirection}
      labelProps={labelProps}
      required={required}
    >
      <Controller
        control={control}
        name={id}
        render={({ field }) => (
          <FileUpload
            label={label}
            disabled={disabled}
            inputProps={inputProps}
            onUpload={(files) => {
              field.onChange(files);
              onChange?.(files);
            }}
            onBlur={() => field.onBlur()}
            {...rest}
          />
        )}
      />
    </Field>
  );
};

export default FormFileUpload;
